import {
  Component,
  Element,
  Event,
  EventEmitter,
  h,
  Host,
  JSX,
  Prop,
  State,
} from "@stencil/core";
import { TLink, TMenu, TVehiclePurchaseMenu } from "@phn/entities/content";
import { constructRoutingKey } from "@phn/entities/routing-key";
import { EventActions } from "@phn/utility/constants";
import { isString } from "@phn/utility/helper";
import { componentsOnReady } from "@phn/utility/ready";
import { Timeout } from "@phn/utility/timeout";
import { finderStateStore } from "@phn/state/finder-state-store";
import { addRoute, getCurrentRoute } from "@phn/services/routing-manager";
import MenuItemLink from "./saved-vehicles/menu-item-link";

@Component({
  tag: "phn-nd-menu",
  styleUrl: "menu.scss",
  scoped: true,
})
export class Menu {
  @Prop() item!: TMenu | TVehiclePurchaseMenu;

  @Prop() showHeadline = true;

  @Prop() receivedContent = false;

  @State() showSkeleton = true;

  @Element() el!: HTMLPhnNdMenuElement;

  @Event({ bubbles: true, cancelable: false })
  mobileMenuItemClick!: EventEmitter<string[]>;

  @Event() showWishlist: EventEmitter<boolean>;

  componentWillLoad(): void {
    this.waitForComponentsToLoad();
  }

  private savedVehiclesPosition = 3;

  private async waitForComponentsToLoad() {
    await componentsOnReady(this.el, new Timeout(5000), false);
    this.showSkeleton = !this.receivedContent;
    this.showWishlist.emit(!this.showSkeleton);
  }

  // TODO: fix this
  private showMenu(childItem: TMenu): void {
    if (!isString(childItem.link)) {
      addRoute([childItem.id]);
    }
  }

  private getSavedVehiclesContent(
    content: TMenu | TVehiclePurchaseMenu,
  ): TLink | null {
    const { savedVehicles } = content as TVehiclePurchaseMenu;
    if (savedVehicles !== undefined) {
      return savedVehicles;
    }
    return null;
  }

  render(): JSX.Element {
    // TODO: check if correct behavior or needs additional checks??????!!!!💩💩💩💩💩💩💩💩💩💩
    const displayedItem =
      this.item.children.length === 1 ? this.item.children[0] : this.item;
    const savedVehicles = this.getSavedVehiclesContent(this.item);
    const { savedVehiclesCount } = finderStateStore.state;

    const menuItems = displayedItem.children.map((childItem) => (
      <li key={childItem.id}>
        <phn-nd-menu-item
          elementId={constructRoutingKey(getCurrentRoute(), childItem.id)}
          iconRight={
            childItem.children.length > 0 && !this.showSkeleton
              ? "arrow-head-right"
              : ""
          }
          analyticsId={childItem.id}
          text={childItem.text}
          link={childItem.link}
          datalayerEventAction={
            isString(childItem.link)
              ? EventActions.NAVIGATION_LINK_CLICK
              : EventActions.NAVIGATION_CLICK
          }
          onClick={() => this.showMenu(childItem)}
        />
      </li>
    ));

    return (
      <Host>
        <ul>
          {menuItems}

          {savedVehicles
            ? menuItems.splice(
                this.savedVehiclesPosition,
                0,
                <MenuItemLink
                  content={savedVehicles}
                  count={savedVehiclesCount}
                />,
              )
            : null}
        </ul>
      </Host>
    );
  }
}
